export enum MENU {
  home = '0',
  service = '1',
  example = '2',
  consult = '3'
}

export enum NOTIFICATION_TYPE {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error'
}

export const CONSTANT = {
  tel: '010-69737628',
  phone: '18310627942',
  mediaWidth: 1260,
};

export const EMAIL = {
  publicKey: 'brgnuSOn48GTWC9ar',
  serviceKey: 'service_br3mrob',
  templateKey: 'template_9a509sn',
};